function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { TOGGLE_SIDENAV_VISIBILITY, TOGGLE_LAYERS_PANEL_VISIBILITY, TOGGLE_RIGHT_MENU_VISIBILITY, COLLAPSE_AUTOMATIC_DATA_TABLE, TOGGLE_MANUAL_DATA_TABLE_VISIBILITY, TOGGLE_AUTOMATIC_DATA_TABLE_VISIBILITY } from '../constants/layout';
var defaultMapState = {
    sideNav: {
        isVisible: false
    },
    rightMenu: {
        isVisible: false
    },
    layersPanel: {
        isVisible: false
    },
    automaticDataTable: {
        isVisible: false,
        isCollapsed: true
    },
    manualDataTable: {
        isVisible: false,
        isCollapsed: true
    }
};
var layoutReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultMapState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case TOGGLE_SIDENAV_VISIBILITY:
            return _object_spread_props(_object_spread({}, state), {
                sideNav: {
                    isVisible: action.payload
                }
            });
        case TOGGLE_RIGHT_MENU_VISIBILITY:
            return _object_spread_props(_object_spread({}, state), {
                rightMenu: {
                    isVisible: action.payload
                }
            });
        case TOGGLE_LAYERS_PANEL_VISIBILITY:
            return _object_spread_props(_object_spread({}, state), {
                layersPanel: {
                    isVisible: action.payload
                }
            });
        case COLLAPSE_AUTOMATIC_DATA_TABLE:
            return _object_spread_props(_object_spread({}, state), {
                automaticDataTable: _object_spread_props(_object_spread({}, state.automaticDataTable), {
                    isCollapsed: action.payload
                })
            });
        case TOGGLE_AUTOMATIC_DATA_TABLE_VISIBILITY:
            return _object_spread_props(_object_spread({}, state), {
                automaticDataTable: _object_spread_props(_object_spread({}, state.automaticDataTable), {
                    isVisible: action.payload
                })
            });
        case TOGGLE_MANUAL_DATA_TABLE_VISIBILITY:
            return _object_spread_props(_object_spread({}, state), {
                manualDataTable: _object_spread_props(_object_spread({}, state.manualDataTable), {
                    isVisible: action.payload
                })
            });
        default:
            return state;
    }
};
export default layoutReducer;
